import { integrationsSelector } from "./integrationsSelector";
import { RootState } from "../../store";
import { Integration } from "../../../services/cloudchipr.api";

export const integrationsDataSelector = (state: RootState): Integration[] => {
  return integrationsSelector(state)?.data ?? [];
};
